module.exports = {
    Activity: require('./Activity'),
  Add: require('./Add'),
  AddCircle: require('./AddCircle'),
  Amex: require('./Amex'),
  AndroidEN: require('./AndroidEN'),
  AndroidFR: require('./AndroidFR'),
  ArrowLeft: require('./ArrowLeft'),
  ArrowRight: require('./ArrowRight'),
  BulletCircle: require('./BulletCircle'),
  BulletFill: require('./BulletFill'),
  Burger: require('./Burger'),
  Calendar: require('./Calendar'),
  Camera: require('./Camera'),
  Chart: require('./Chart'),
  Chat: require('./Chat'),
  Check: require('./Check'),
  CheckMark: require('./CheckMark'),
  ChevronDoubleRight: require('./ChevronDoubleRight'),
  ChevronDown: require('./ChevronDown'),
  ChevronLeft: require('./ChevronLeft'),
  ChevronRight: require('./ChevronRight'),
  ChevronUp: require('./ChevronUp'),
  Close: require('./Close'),
  ClosedCaptions: require('./ClosedCaptions'),
  Copy: require('./Copy'),
  Credit: require('./Credit'),
  CreditCard: require('./CreditCard'),
  Deduct: require('./Deduct'),
  Delete: require('./Delete'),
  Download: require('./Download'),
  Edit: require('./Edit'),
  Email: require('./Email'),
  Emoji: require('./Emoji'),
  Error: require('./Error'),
  Esim: require('./Esim'),
  Expand: require('./Expand'),
  EyeMasked: require('./EyeMasked'),
  EyeUnmasked: require('./EyeUnmasked'),
  Filter: require('./Filter'),
  FullscreenExpand: require('./FullscreenExpand'),
  FullscreenMinimize: require('./FullscreenMinimize'),
  Handshake: require('./Handshake'),
  Help: require('./Help'),
  Home: require('./Home'),
  IOSEN: require('./IOSEN'),
  IOSFR: require('./IOSFR'),
  Info: require('./Info'),
  LinkExternal: require('./LinkExternal'),
  Lock: require('./Lock'),
  MasterCard: require('./MasterCard'),
  MobileArrowBack: require('./MobileArrowBack'),
  MobileArrowRight: require('./MobileArrowRight'),
  MobileCamera: require('./MobileCamera'),
  MobileCaretDown: require('./MobileCaretDown'),
  MobileChat: require('./MobileChat'),
  MobileCheckbox: require('./MobileCheckbox'),
  MobileCheckmark: require('./MobileCheckmark'),
  MobileDownArrow: require('./MobileDownArrow'),
  MobileFeatherSearch: require('./MobileFeatherSearch'),
  MobileGroup: require('./MobileGroup'),
  MobileIconFilter: require('./MobileIconFilter'),
  MobileInputWarningError: require('./MobileInputWarningError'),
  MobileLightening: require('./MobileLightening'),
  MobileListIcon: require('./MobileListIcon'),
  MobileMaterialError: require('./MobileMaterialError'),
  MobileOverviewCheckbox: require('./MobileOverviewCheckbox'),
  MobilePMLogo: require('./MobilePMLogo'),
  MobileRadioSelected: require('./MobileRadioSelected'),
  MobileRadioUnSelected: require('./MobileRadioUnSelected'),
  MobileRefresh: require('./MobileRefresh'),
  MobileRewards: require('./MobileRewards'),
  MobileSaleTag: require('./MobileSaleTag'),
  MobileShareNumber: require('./MobileShareNumber'),
  MobileUncheckedCheckbox: require('./MobileUncheckedCheckbox'),
  MobileUpArrow: require('./MobileUpArrow'),
  MobileWarningError: require('./MobileWarningError'),
  MobileWaves: require('./MobileWaves'),
  MobileXClose: require('./MobileXClose'),
  MobileXMark: require('./MobileXMark'),
  Muted: require('./Muted'),
  Notification: require('./Notification'),
  Options: require('./Options'),
  Pause: require('./Pause'),
  Payment: require('./Payment'),
  Person: require('./Person'),
  Phone: require('./Phone'),
  PhoneIncoming: require('./PhoneIncoming'),
  PhoneLandline: require('./PhoneLandline'),
  PhoneOutgoing: require('./PhoneOutgoing'),
  PinLocation: require('./PinLocation'),
  PlaySolid: require('./PlaySolid'),
  PlayVideo: require('./PlayVideo'),
  Printer: require('./Printer'),
  QuoteLeft: require('./QuoteLeft'),
  QuoteLeftArrow: require('./QuoteLeftArrow'),
  QuoteRightArrow: require('./QuoteRightArrow'),
  Receipt: require('./Receipt'),
  Refresh: require('./Refresh'),
  Replay: require('./Replay'),
  Rewards: require('./Rewards'),
  Search: require('./Search'),
  Send: require('./Send'),
  Settings: require('./Settings'),
  SettingsSolid: require('./SettingsSolid'),
  Share: require('./Share'),
  Shop: require('./Shop'),
  Sim: require('./Sim'),
  SmsReceive: require('./SmsReceive'),
  SmsSend: require('./SmsSend'),
  Speed: require('./Speed'),
  Subscription: require('./Subscription'),
  Subtract: require('./Subtract'),
  Tag: require('./Tag'),
  Target: require('./Target'),
  ThumbsUp: require('./ThumbsUp'),
  Transfer: require('./Transfer'),
  Unlock: require('./Unlock'),
  Unmuted: require('./Unmuted'),
  Visa: require('./Visa'),
  Visible: require('./Visible'),
  WarningError: require('./WarningError'),
  Wifi: require('./Wifi'),
  XMark: require('./XMark'),
  XMarkCircle: require('./XMarkCircle')
}